import { apiClient } from './client';
import { endpoints } from './endpoints';
import type { CollectionsSettingsDto } from '../types/api';

export async function getCollectionsSettings(): Promise<CollectionsSettingsDto> {
  const res = await apiClient.get<CollectionsSettingsDto>(
    endpoints.collectionsSettings.get,
  );
  return res.data;
}

export async function updateCollectionsSettings(
  input: Partial<CollectionsSettingsDto>,
): Promise<CollectionsSettingsDto> {
  const res = await apiClient.patch<CollectionsSettingsDto, Partial<CollectionsSettingsDto>>(
    endpoints.collectionsSettings.update,
    input,
  );
  return res.data;
}
